import React from 'react';
import { Menu } from 'react-data-grid-addons';
import AddColumnMenu from './AddColumnMenu.jsx';
import { hasSavedColumns } from '../utils/gridActions.js';

const { ContextMenu, MenuItem } = Menu;

export default function TransactionGridContextMenu({ id, idx, rowIdx, hideCol, openDetails, openLink, resetColumns, cookies, columns, currentColumns, onAdd }) {
	return (
		<ContextMenu id={id}>
			<MenuItem data={{ rowIdx }} onClick={openDetails}>View details</MenuItem>
			<MenuItem data={{ rowIdx }} onClick={openLink}>View CapPay link</MenuItem>
			<MenuItem divider />
			<AddColumnMenu columns={columns} currentColumns={currentColumns} onAdd={onAdd} />
			<MenuItem data={{ rowIdx, idx }} onClick={hideCol}>Remove Column {idx}</MenuItem>
			{hasSavedColumns(cookies) &&
				<MenuItem onClick={resetColumns}>Reset columns</MenuItem>}
		</ContextMenu>
	);
}